import React, { useState, useEffect, useRef } from "react";
import "./ActionDropdown.css";

const ActionDropdown = ({ 
  isOpen,
  setOpenRowId,
  rowId,
  buttons = [],
}) => {
  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const toggleDropdown = () => {
    if (!buttons || buttons.length === 0) return; // Don't open if no buttons
    
    if (!isOpen) {
      // Calculate position when opening
      const buttonRect = dropdownRef.current.getBoundingClientRect();
      const dropdownHeight = 150; // Approximate height of the dropdown
      const windowHeight = window.innerHeight;
      
      // Check if dropdown would go off the bottom of the screen
      const wouldGoOffBottom = buttonRect.bottom + dropdownHeight > windowHeight;
      
      // Position the dropdown
      setDropdownPosition({
        top: wouldGoOffBottom 
          ? buttonRect.top - dropdownHeight // Position above the button if it would go off bottom
          : buttonRect.bottom, // Position below the button otherwise
        left: buttonRect.left - 150 + buttonRect.width // Position to the left of the button
      });
    }
    setOpenRowId(isOpen ? null : rowId);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenRowId(null);
    }
  };

  // Close dropdown when scrolling
  const handleScroll = () => {
    if (isOpen) {
      setOpenRowId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", handleScroll, true);
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [isOpen]);

  return (
    <div className="action-dropdown" ref={dropdownRef} onMouseDown={(e) => e.stopPropagation()}>
      <button className="action-button" onClick={toggleDropdown}>
        &#x2022;&#x2022;&#x2022; {/* Horizontal three dots (ellipsis) */}
      </button>
      {isOpen && (
        <div 
          className="dropdown-menu"
          style={{
            position: 'fixed',
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            zIndex: 2000
          }}
        >
          {buttons.length > 0 && (
            buttons.map((button, index) => (
              <div 
                key={index} 
                className="dropdown-item"
                onClick={() => {
                  button.onClick?.(); // Trigger button's onClick handler if defined
                  toggleDropdown(); // Close dropdown after click
                }}
              >
                {button.label}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
